module.exports = __webpack_public_path__ + "img/CarRentalOutlined.cbb4c003.svg";